import React from 'react';

export const SvgSentimentSatisfied = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12zm6.5-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm7 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.38-5.87c.21-.35.68-.46 1.03-.24.35.22.46.68.24 1.03-1.02 1.61-2.75 2.58-4.65 2.58-1.9 0-3.63-.96-4.65-2.59a.747.747 0 111.27-.79C9.36 15.3 10.62 16 12 16s2.64-.7 3.38-1.87z"
      fill="currentColor"
    />
  </svg>
);
